import React, { isValidElement } from 'react';

import Slugger from 'github-slugger';
import striptags from 'striptags';

export const useHeaderId = (): [
  (value: string | React.ReactNode[]) => [string, string],
] => {
  const slugger = new Slugger();

  const getSlug = (value: string | React.ReactNode[]): [string, string] => {
    let label = '';

    if (typeof value === 'string') {
      label = value;
    } else if (Array.isArray(value)) {
      React.Children.forEach<'string' | React.ReactNode>(value, child => {
        if (typeof child === 'string') {
          label += child;
        } else if (
          isValidElement(child) &&
          typeof child === 'object' &&
          typeof child?.props?.children === 'string'
        ) {
          label += child.props.children;
        }
      });
    }

    const text = striptags(label);
    // create a slug and remove - from the end if there is nothing following it
    const slug = slugger.slug(text).replace(/-$/, '');
    return [slug, text];
  };

  return [getSlug];
};
